/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_VerdictInputs */

const en_pc_rv_verdict = /** @type {(inputs: Pc_Rv_VerdictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft is the most convincing free take on the Photoshop experience so far. Hobbyists, students, Linux users and anyone who only needs Photoshop occasionally should install it today. Professionals can treat it as a promising second tool for now.`)
};

const zh_pc_rv_verdict = /** @type {(inputs: Pc_Rv_VerdictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft 是目前最有说服力的免费 Photoshop 体验。爱好者、学生、Linux 用户，以及偶尔才用 Photoshop 的人，现在就值得装上。专业用户暂时可以把它当作一个很有潜力的第二工具。`)
};

/**
* | output |
* | --- |
* | "PhotoCraft is the most convincing free take on the Photoshop experience so far. Hobbyists, students, Linux users and anyone who only needs Photoshop occasion..." |
*
* @param {Pc_Rv_VerdictInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_verdict = /** @type {((inputs?: Pc_Rv_VerdictInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_VerdictInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_verdict(inputs)
	return zh_pc_rv_verdict(inputs)
});
export { pc_rv_verdict as "pc.rv.verdict" }